import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(getAuthors),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(__unstableGetAuthor),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(getCurrentUser),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(getEntityRecord),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(getEntityRecords),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(getCurrentTheme),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(getThemeSupports),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(getEmbedPreview),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(hasUploadPermissions),
    _marked10 = /*#__PURE__*/_regeneratorRuntime.mark(canUser),
    _marked11 = /*#__PURE__*/_regeneratorRuntime.mark(getAutosaves),
    _marked12 = /*#__PURE__*/_regeneratorRuntime.mark(getAutosave),
    _marked13 = /*#__PURE__*/_regeneratorRuntime.mark(__experimentalGetTemplateForLink);

/**
 * External dependencies
 */
import { find, includes, get, hasIn, compact, uniq } from 'lodash';
/**
 * WordPress dependencies
 */

import { addQueryArgs } from '@wordpress/url';
import deprecated from '@wordpress/deprecated';
import { controls } from '@wordpress/data';
import { apiFetch } from '@wordpress/data-controls';
/**
 * Internal dependencies
 */

import { regularFetch } from './controls';
/**
 * Internal dependencies
 */

import { receiveUserQuery, receiveCurrentTheme, receiveCurrentUser, receiveEntityRecords, receiveThemeSupports, receiveEmbedPreview, receiveUserPermission, receiveAutosaves } from './actions';
import { getKindEntities, DEFAULT_ENTITY_KEY } from './entities';
import { ifNotResolved, getNormalizedCommaSeparable } from './utils';
import { __unstableAcquireStoreLock, __unstableReleaseStoreLock } from './locks';
/**
 * Requests authors from the REST API.
 *
 * @param {Object|undefined} query Optional object of query parameters to
 *                                 include with request.
 */

export function getAuthors(query) {
  var path, users;
  return _regeneratorRuntime.wrap(function getAuthors$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          path = addQueryArgs('/wp/v2/users/?who=authors&per_page=100', query);
          _context.next = 3;
          return apiFetch({
            path: path
          });

        case 3:
          users = _context.sent;
          _context.next = 6;
          return receiveUserQuery(path, users);

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * Temporary approach to resolving editor access to author queries.
 *
 * @param {number} id The author id.
 */

export function __unstableGetAuthor(id) {
  var path, users;
  return _regeneratorRuntime.wrap(function __unstableGetAuthor$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          path = "/wp/v2/users?who=authors&include=".concat(id);
          _context2.next = 3;
          return apiFetch({
            path: path
          });

        case 3:
          users = _context2.sent;
          _context2.next = 6;
          return receiveUserQuery('author', users);

        case 6:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * Requests the current user from the REST API.
 */

export function getCurrentUser() {
  var currentUser;
  return _regeneratorRuntime.wrap(function getCurrentUser$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return apiFetch({
            path: '/wp/v2/users/me'
          });

        case 2:
          currentUser = _context3.sent;
          _context3.next = 5;
          return receiveCurrentUser(currentUser);

        case 5:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
/**
 * Requests an entity's record from the REST API.
 *
 * @param {string}           kind  Entity kind.
 * @param {string}           name  Entity name.
 * @param {number|string}    key   Record's key
 * @param {Object|undefined} query Optional object of query parameters to
 *                                 include with request.
 */

export function getEntityRecord(kind, name) {
  var key,
      query,
      entities,
      entity,
      lock,
      path,
      hasRecords,
      record,
      _args4 = arguments;
  return _regeneratorRuntime.wrap(function getEntityRecord$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          key = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : '';
          query = _args4.length > 3 ? _args4[3] : undefined;
          _context4.next = 4;
          return getKindEntities(kind);

        case 4:
          entities = _context4.sent;
          entity = find(entities, {
            kind: kind,
            name: name
          });

          if (entity) {
            _context4.next = 8;
            break;
          }

          return _context4.abrupt("return");

        case 8:
          return _context4.delegateYield(__unstableAcquireStoreLock('core', ['entities', 'data', kind, name, key], {
            exclusive: false
          }), "t0", 9);

        case 9:
          lock = _context4.t0;
          _context4.prev = 10;

          if (query !== undefined && query._fields) {
            // If requesting specific fields, items and query assocation to said
            // records are stored by ID reference. Thus, fields must always include
            // the ID.
            query = _objectSpread(_objectSpread({}, query), {}, {
              _fields: uniq([].concat(_toConsumableArray(getNormalizedCommaSeparable(query._fields) || []), [entity.key || DEFAULT_ENTITY_KEY])).join()
            });
          } // Disable reason: While true that an early return could leave `path`
          // unused, it's important that path is derived using the query prior to
          // additional query modifications in the condition below, since those
          // modifications are relevant to how the data is tracked in state, and not
          // for how the request is made to the REST API.
          // eslint-disable-next-line @wordpress/no-unused-vars-before-return


          path = addQueryArgs(entity.baseURL + '/' + key, _objectSpread(_objectSpread({}, query), {}, {
            context: 'edit'
          }));

          if (!(query !== undefined)) {
            _context4.next = 20;
            break;
          }

          query = _objectSpread(_objectSpread({}, query), {}, {
            include: [key]
          }); // The resolution cache won't consider query as reusable based on the
          // fields, so it's tested here, prior to initiating the REST request,
          // and without causing `getEntityRecords` resolution to occur.

          _context4.next = 17;
          return controls.select('core', 'hasEntityRecords', kind, name, query);

        case 17:
          hasRecords = _context4.sent;

          if (!hasRecords) {
            _context4.next = 20;
            break;
          }

          return _context4.abrupt("return");

        case 20:
          _context4.next = 22;
          return apiFetch({
            path: path
          });

        case 22:
          record = _context4.sent;
          _context4.next = 25;
          return receiveEntityRecords(kind, name, record, query);

        case 25:
          _context4.prev = 25;
          return _context4.delegateYield(__unstableReleaseStoreLock(lock), "t1", 27);

        case 27:
          return _context4.finish(25);

        case 28:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[10,, 25, 28]]);
}
/**
 * Requests an entity's record from the REST API.
 */

export var getRawEntityRecord = ifNotResolved(getEntityRecord, 'getEntityRecord');
/**
 * Requests an entity's record from the REST API.
 */

export var getEditedEntityRecord = ifNotResolved(getRawEntityRecord, 'getRawEntityRecord');
/**
 * Requests the entity's records from the REST API.
 *
 * @param {string}  kind   Entity kind.
 * @param {string}  name   Entity name.
 * @param {Object?} query  Query Object.
 */

export function getEntityRecords(kind, name) {
  var query,
      entities,
      entity,
      lock,
      _query,
      path,
      records,
      key,
      _iterator,
      _step,
      record,
      _args5 = arguments;

  return _regeneratorRuntime.wrap(function getEntityRecords$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          query = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
          _context5.next = 3;
          return getKindEntities(kind);

        case 3:
          entities = _context5.sent;
          entity = find(entities, {
            kind: kind,
            name: name
          });

          if (entity) {
            _context5.next = 7;
            break;
          }

          return _context5.abrupt("return");

        case 7:
          return _context5.delegateYield(__unstableAcquireStoreLock('core', ['entities', 'data', kind, name], {
            exclusive: false
          }), "t0", 8);

        case 8:
          lock = _context5.t0;
          _context5.prev = 9;

          if (query._fields) {
            // If requesting specific fields, items and query assocation to said
            // records are stored by ID reference. Thus, fields must always include
            // the ID.
            query = _objectSpread(_objectSpread({}, query), {}, {
              _fields: uniq([].concat(_toConsumableArray(getNormalizedCommaSeparable(query._fields) || []), [entity.key || DEFAULT_ENTITY_KEY])).join()
            });
          }

          path = addQueryArgs(entity.baseURL, _objectSpread(_objectSpread({}, query), {}, {
            context: 'edit'
          }));
          _context5.t1 = Object;
          _context5.next = 15;
          return apiFetch({
            path: path
          });

        case 15:
          _context5.t2 = _context5.sent;
          records = _context5.t1.values.call(_context5.t1, _context5.t2);

          // If we request fields but the result doesn't contain the fields,
          // explicitely set these fields as "undefined"
          // that way we consider the query "fullfilled".
          if (query._fields) {
            records = records.map(function (record) {
              query._fields.split(',').forEach(function (field) {
                if (!record.hasOwnProperty(field)) {
                  record[field] = undefined;
                }
              });

              return record;
            });
          }

          _context5.next = 20;
          return receiveEntityRecords(kind, name, records, query);

        case 20:
          if ((_query = query) !== null && _query !== void 0 && _query._fields) {
            _context5.next = 42;
            break;
          }

          key = entity.key || DEFAULT_ENTITY_KEY;
          _iterator = _createForOfIteratorHelper(records);
          _context5.prev = 23;

          _iterator.s();

        case 25:
          if ((_step = _iterator.n()).done) {
            _context5.next = 34;
            break;
          }

          record = _step.value;

          if (!record[key]) {
            _context5.next = 32;
            break;
          }

          _context5.next = 30;
          return {
            type: 'START_RESOLUTION',
            selectorName: 'getEntityRecord',
            args: [kind, name, record[key]]
          };

        case 30:
          _context5.next = 32;
          return {
            type: 'FINISH_RESOLUTION',
            selectorName: 'getEntityRecord',
            args: [kind, name, record[key]]
          };

        case 32:
          _context5.next = 25;
          break;

        case 34:
          _context5.next = 39;
          break;

        case 36:
          _context5.prev = 36;
          _context5.t3 = _context5["catch"](23);

          _iterator.e(_context5.t3);

        case 39:
          _context5.prev = 39;

          _iterator.f();

          return _context5.finish(39);

        case 42:
          _context5.prev = 42;
          return _context5.delegateYield(__unstableReleaseStoreLock(lock), "t4", 44);

        case 44:
          return _context5.finish(42);

        case 45:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[9,, 42, 45], [23, 36, 39, 42]]);
}

getEntityRecords.shouldInvalidate = function (action, kind, name) {
  return (action.type === 'RECEIVE_ITEMS' || action.type === 'REMOVE_ITEMS') && action.invalidateCache && kind === action.kind && name === action.name;
};
/**
 * Requests the current theme.
 */


export function getCurrentTheme() {
  var activeThemes;
  return _regeneratorRuntime.wrap(function getCurrentTheme$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return apiFetch({
            path: '/wp/v2/themes?status=active'
          });

        case 2:
          activeThemes = _context6.sent;
          _context6.next = 5;
          return receiveCurrentTheme(activeThemes[0]);

        case 5:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
/**
 * Requests theme supports data from the index.
 */

export function getThemeSupports() {
  var activeThemes;
  return _regeneratorRuntime.wrap(function getThemeSupports$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return apiFetch({
            path: '/wp/v2/themes?status=active'
          });

        case 2:
          activeThemes = _context7.sent;
          _context7.next = 5;
          return receiveThemeSupports(activeThemes[0].theme_supports);

        case 5:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
/**
 * Requests a preview from the from the Embed API.
 *
 * @param {string} url   URL to get the preview for.
 */

export function getEmbedPreview(url) {
  var embedProxyResponse;
  return _regeneratorRuntime.wrap(function getEmbedPreview$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return apiFetch({
            path: addQueryArgs('/oembed/1.0/proxy', {
              url: url
            })
          });

        case 3:
          embedProxyResponse = _context8.sent;
          _context8.next = 6;
          return receiveEmbedPreview(url, embedProxyResponse);

        case 6:
          _context8.next = 12;
          break;

        case 8:
          _context8.prev = 8;
          _context8.t0 = _context8["catch"](0);
          _context8.next = 12;
          return receiveEmbedPreview(url, false);

        case 12:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[0, 8]]);
}
/**
 * Requests Upload Permissions from the REST API.
 *
 * @deprecated since 5.0. Callers should use the more generic `canUser()` selector instead of
 *            `hasUploadPermissions()`, e.g. `canUser( 'create', 'media' )`.
 */

export function hasUploadPermissions() {
  return _regeneratorRuntime.wrap(function hasUploadPermissions$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          deprecated("select( 'core' ).hasUploadPermissions()", {
            alternative: "select( 'core' ).canUser( 'create', 'media' )"
          });
          return _context9.delegateYield(canUser('create', 'media'), "t0", 2);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}
/**
 * Checks whether the current user can perform the given action on the given
 * REST resource.
 *
 * @param {string}  action   Action to check. One of: 'create', 'read', 'update',
 *                           'delete'.
 * @param {string}  resource REST resource to check, e.g. 'media' or 'posts'.
 * @param {?string} id       ID of the rest resource to check.
 */

export function canUser(action, resource, id) {
  var methods, method, path, response, allowHeader, key, isAllowed;
  return _regeneratorRuntime.wrap(function canUser$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          methods = {
            create: 'POST',
            read: 'GET',
            update: 'PUT',
            delete: 'DELETE'
          };
          method = methods[action];

          if (method) {
            _context10.next = 4;
            break;
          }

          throw new Error("'".concat(action, "' is not a valid action."));

        case 4:
          path = id ? "/wp/v2/".concat(resource, "/").concat(id) : "/wp/v2/".concat(resource);
          _context10.prev = 5;
          _context10.next = 8;
          return apiFetch({
            path: path,
            // Ideally this would always be an OPTIONS request, but unfortunately there's
            // a bug in the REST API which causes the Allow header to not be sent on
            // OPTIONS requests to /posts/:id routes.
            // https://core.trac.wordpress.org/ticket/45753
            method: id ? 'GET' : 'OPTIONS',
            parse: false
          });

        case 8:
          response = _context10.sent;
          _context10.next = 14;
          break;

        case 11:
          _context10.prev = 11;
          _context10.t0 = _context10["catch"](5);
          return _context10.abrupt("return");

        case 14:
          if (hasIn(response, ['headers', 'get'])) {
            // If the request is fetched using the fetch api, the header can be
            // retrieved using the 'get' method.
            allowHeader = response.headers.get('allow');
          } else {
            // If the request was preloaded server-side and is returned by the
            // preloading middleware, the header will be a simple property.
            allowHeader = get(response, ['headers', 'Allow'], '');
          }

          key = compact([action, resource, id]).join('/');
          isAllowed = includes(allowHeader, method);
          _context10.next = 19;
          return receiveUserPermission(key, isAllowed);

        case 19:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10, null, [[5, 11]]);
}
/**
 * Request autosave data from the REST API.
 *
 * @param {string} postType The type of the parent post.
 * @param {number} postId   The id of the parent post.
 */

export function getAutosaves(postType, postId) {
  var _yield$controls$resol, restBase, autosaves;

  return _regeneratorRuntime.wrap(function getAutosaves$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return controls.resolveSelect('core', 'getPostType', postType);

        case 2:
          _yield$controls$resol = _context11.sent;
          restBase = _yield$controls$resol.rest_base;
          _context11.next = 6;
          return apiFetch({
            path: "/wp/v2/".concat(restBase, "/").concat(postId, "/autosaves?context=edit")
          });

        case 6:
          autosaves = _context11.sent;

          if (!(autosaves && autosaves.length)) {
            _context11.next = 10;
            break;
          }

          _context11.next = 10;
          return receiveAutosaves(postId, autosaves);

        case 10:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}
/**
 * Request autosave data from the REST API.
 *
 * This resolver exists to ensure the underlying autosaves are fetched via
 * `getAutosaves` when a call to the `getAutosave` selector is made.
 *
 * @param {string} postType The type of the parent post.
 * @param {number} postId   The id of the parent post.
 */

export function getAutosave(postType, postId) {
  return _regeneratorRuntime.wrap(function getAutosave$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return controls.resolveSelect('core', 'getAutosaves', postType, postId);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}
/**
 * Retrieve the frontend template used for a given link.
 *
 * @param {string} link  Link.
 */

export function __experimentalGetTemplateForLink(link) {
  var template, record;
  return _regeneratorRuntime.wrap(function __experimentalGetTemplateForLink$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return regularFetch(addQueryArgs(link, {
            '_wp-find-template': true
          }));

        case 2:
          template = _context13.sent;

          if (!(template === null)) {
            _context13.next = 5;
            break;
          }

          return _context13.abrupt("return");

        case 5:
          _context13.next = 7;
          return getEntityRecord('postType', 'wp_template', template.ID);

        case 7:
          _context13.next = 9;
          return controls.select('core', 'getEntityRecord', 'postType', 'wp_template', template.ID);

        case 9:
          record = _context13.sent;

          if (!record) {
            _context13.next = 13;
            break;
          }

          _context13.next = 13;
          return receiveEntityRecords('postType', 'wp_template', [record], {
            'find-template': link
          });

        case 13:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}
//# sourceMappingURL=resolvers.js.map